import { ShieldCheck } from "lucide-react";

export const Navbar = () => (
  <header className="fixed top-0 left-0 right-0 z-50">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
      <nav
        data-testid="main-navbar"
        className="glass-card rounded-full px-5 py-3 flex items-center justify-between"
      >
        <a href="/" data-testid="brand-link" className="flex items-center gap-2 min-w-0">
          <ShieldCheck className="w-5 h-5 shrink-0 text-[#2E9FDB]" strokeWidth={2.2} />
          <span className="font-heading font-bold text-[11px] sm:text-base tracking-tight text-slate-900 truncate">
            DESPACHANTES<span className="text-[#2E9FDB]">DETRAN</span>
            <span className="hidden sm:inline text-slate-500 font-medium">.COM.BR</span>
          </span>
        </a>
        <a
          href="#solicitar"
          data-testid="navbar-cta"
          className="btn-cta shrink-0 whitespace-nowrap bg-[#2E9FDB] text-[#06305F] font-heading font-semibold text-[10px] sm:text-sm px-3.5 sm:px-6 py-2 rounded-full uppercase tracking-wide"
        >
          Solicitar atendimento
        </a>
      </nav>
    </div>
  </header>
);
